import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { NFMV, NotaFiscalEletronica } from "@interfaces/nfe";
import { NfePayload } from "@interfaces/nfe-payload";
import { HttpService } from "./http.service";

export type NfeIssueResponse =
  | NotaFiscalEletronica
  | {
      data?: NotaFiscalEletronica;
      nota?: NotaFiscalEletronica;
      nfe?: NotaFiscalEletronica;
    };

@Injectable({
  providedIn: "root"
})
export class NfeService {
  url = `${environment.api.mv.nf}/nfe`;

  constructor(private readonly httpService: HttpService) {}

  issue(payload: Partial<NfePayload>) {
    return this.httpService.post<NfeIssueResponse>(this.url, {
      ...payload
    });
  }

  fetchNfes(
    dataInicial: string | null,
    dataFinal: string | null,
    page = 1,
    limit = 10
  ) {
    const params: string[] = [];
    if (dataInicial) params.push(`dataInicial=${dataInicial}`);
    if (dataFinal) params.push(`dataFinal=${dataFinal}`);
    params.push(`page=${page}`, `limit=${limit}`);

    const queryString = params.join("&");

    return this.httpService.get<{
      data: NotaFiscalEletronica[];
      meta: {
        page: number;
        limit: number;
        total: number;
        totalPages: number;
      };
    }>(`${this.url}?${queryString}`);
  }

  syncNfes(dataInicial: string | null, dataFinal: string | null) {
    const params: string[] = [];
    if (dataInicial) params.push(`dataInicial=${dataInicial}`);
    if (dataFinal) params.push(`dataFinal=${dataFinal}`);

    const queryString = params.length ? `?${params.join("&")}` : "";

    return this.httpService.get(`${this.url}/atualizar${queryString}`);
  }

  fetcMVInvoices(ids: string[]) {
    return this.httpService.get<NFMV[]>(`${this.url}/ids?ids=${ids.join(",")}`);
  }

  downloadNfeFile(idNota: string, type: "pdf" | "xml") {
    return this.httpService.getBlob(`${this.url}/download/${type}/${idNota}`);
  }

  reprintNfePdf(
    idNota: string,
    payload: {
      tipoImpressao?: string;
      modeloImpressao?: string;
    }
  ) {
    return this.httpService.postBlob(
      `${this.url}/download/pdf/${idNota}/reimpressao`,
      payload
    );
  }

  downloadNfeBatch(dataInicial: string, dataFinal: string) {
    const params = new URLSearchParams({
      dataInicial,
      dataFinal
    });

    return this.httpService.getBlob(`${this.url}/download/lote?${params}`);
  }

  getExternalNfeDownloadLink(idNota: string, type: "pdf" | "xml") {
    return this.httpService.get<{ url: string }>(
      `${this.url}/download/${type}/${idNota}/external-link`
    );
  }

  requestNfeCorrection(nfeId: string, correcao: string) {
    return this.httpService.post(`${this.url}/${nfeId}/cce`, {
      correcao
    });
  }

  requestNfeCancellation(nfeId: string, justificativa: string) {
    return this.httpService.post(`${this.url}/${nfeId}/cancelamento`, {
      justificativa
    });
  }
}
